import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-tickets',
    templateUrl: './tickets.component.html',
    styleUrls: ['./tickets.component.scss'],
    standalone: false
})
export class TicketsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
